// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.global_wrapper__1r5aK{
    padding: 0px 0px 0px 0px;
    background-color: var( --referral-global-main-background);
}
.global_container__y8Nfh{
    max-width: 500px;
    margin: auto;
}
.global_ptbl10__piZ7V{
    padding:10px;
  }
  .global_ptbl15__elFG-{
    padding:15px;
  }
  .global_ptbl12__NGXPP{
    padding:12px;
  }
  .global_pt10__yyOj-{
    padding-top: 10px;
  }
  .global_pb10__0a7yB{
    padding-bottom: 10px;
  }
  .global_pb20__NxsAm{
    padding-bottom: 20px;
  }
  .global_ptb10__mlVOD{
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .global_pl10__rbL5y{
    padding-left: 10px;
  }
  .global_pr10__f20KT{
    padding-right: 10px;
  }
  .global_plr10__JnjLT{
    padding-left: 10px;
    padding-right: 10px;
  }
.global_mt10__LUIG2{
    margin-top: 10px;
}
.global_mb10__NsY\\+w{
    margin-bottom: 10px;
}
.global_flex0__IVIPD{
    flex: 0 1;
}
.global_flex1__B3ULo{
    flex: 1 1;
}
.global_flex2__4PFPt{
    flex: 2 1;
}
.global_flex3__EsyNm{
    flex: 3 1;
}
.global_flex4__xhvaE{
    flex: 4 1;
}
.global_flex5__bYRMQ{
    flex: 5 1;
}
.global_flex6__AM9dY{
    flex: 6 1;
}
.global_questionBox__LcqM6{
    width: 100%;
    display: inline-block;
    background-color: var(--referral-blue-background);
}
.global_questionBoxInner__EAhnx{
  width: 100%;
    text-align: right;
    padding: 8px;
}
.global_blankspacetop__1oIX2{
    height: 68px;
    background-color: var(--referral-blue-background);
}
.global_inlineError__I8SYK{
  color: var(--referral-theme-danger);
  display: block;
  padding-left: 16px;
}
.global_gredintbox__kNQlO{
        width: 100%; 
        background-color: var(--referral-global-main-background);
}
.global_marginTopsticky__octf-{
  margin-top: 68px;
}

.global_animateBox__pnBLu {
  animation: global_animateBox__pnBLu 1s forwards ease-out;
}

.global_bannerImage__erAgt img{
  width: 100%;
  height: auto;
}

@keyframes global_animateBox__pnBLu {
  from {
      transform: translateY(100px);
      opacity: 0;
  }
  to {
      transform: translateY(0);
      opacity: 1;
  }
}
.global_tierBox__-Hdf7{
  left: 0;
  right: 0;
  margin: auto;
}
.global_innwrapper__pifpL{
  display: block;
}
.global_videoContainer__FoQ7m{
  position: relative;
}
.global_videoAbsolute__n8mSc{
  position: absolute;
  top: -48px;
}
.global_questionBoxScroll__ulWdm{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 100;
  background-color: var(--white);
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.08);
}
.global_video__2-ouU{
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      gap: 10px;
}
.global_videoInnerImageIcon__uHtar{
  width: 180px;
  height: auto;
  padding: 20px;
}
.global_videoInnerTextTitle__UfJr\\+{
  color: var(--white);
}
.global_videoInnerImage__rKBrA{
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/styles/referral/global.module.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,yDAAyD;AAC7D;AACA;IACI,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,SAAO;AACX;AACA;IACI,SAAO;AACX;AACA;IACI,SAAO;AACX;AACA;IACI,SAAO;AACX;AACA;IACI,SAAO;AACX;AACA;IACI,SAAO;AACX;AACA;IACI,SAAO;AACX;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,iDAAiD;AACrD;AACA;EACE,WAAW;IACT,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,YAAY;IACZ,iDAAiD;AACrD;AACA;EACE,mCAAmC;EACnC,cAAc;EACd,kBAAkB;AACpB;AACA;QACQ,WAAW;QACX,wDAAwD;AAChE;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,wDAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;MACI,4BAA4B;MAC5B,UAAU;EACd;EACA;MACI,wBAAwB;MACxB,UAAU;EACd;AACF;AACA;EACE,OAAO;EACP,QAAQ;EACR,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,+CAA+C;AACjD;AACA;EACE,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;MACT,uBAAuB;MACvB,mBAAmB;MACnB,sBAAsB;MACtB,SAAS;AACf;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB","sourcesContent":[".wrapper{\n    padding: 0px 0px 0px 0px;\n    background-color: var( --referral-global-main-background);\n}\n.container{\n    max-width: 500px;\n    margin: auto;\n}\n.ptbl10{\n    padding:10px;\n  }\n  .ptbl15{\n    padding:15px;\n  }\n  .ptbl12{\n    padding:12px;\n  }\n  .pt10{\n    padding-top: 10px;\n  }\n  .pb10{\n    padding-bottom: 10px;\n  }\n  .pb20{\n    padding-bottom: 20px;\n  }\n  .ptb10{\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n  .pl10{\n    padding-left: 10px;\n  }\n  .pr10{\n    padding-right: 10px;\n  }\n  .plr10{\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n.mt10{\n    margin-top: 10px;\n}\n.mb10{\n    margin-bottom: 10px;\n}\n.flex0{\n    flex: 0;\n}\n.flex1{\n    flex: 1;\n}\n.flex2{\n    flex: 2;\n}\n.flex3{\n    flex: 3;\n}\n.flex4{\n    flex: 4;\n}\n.flex5{\n    flex: 5;\n}\n.flex6{\n    flex: 6;\n}\n.questionBox{\n    width: 100%;\n    display: inline-block;\n    background-color: var(--referral-blue-background);\n}\n.questionBoxInner{\n  width: 100%;\n    text-align: right;\n    padding: 8px;\n}\n.blankspacetop{\n    height: 68px;\n    background-color: var(--referral-blue-background);\n}\n.inlineError{\n  color: var(--referral-theme-danger);\n  display: block;\n  padding-left: 16px;\n}\n.gredintbox{\n        width: 100%; \n        background-color: var(--referral-global-main-background);\n}\n.marginTopsticky{\n  margin-top: 68px;\n}\n\n.animateBox {\n  animation: animateBox 1s forwards ease-out;\n}\n\n.bannerImage img{\n  width: 100%;\n  height: auto;\n}\n\n@keyframes animateBox {\n  from {\n      transform: translateY(100px);\n      opacity: 0;\n  }\n  to {\n      transform: translateY(0);\n      opacity: 1;\n  }\n}\n.tierBox{\n  left: 0;\n  right: 0;\n  margin: auto;\n}\n.innwrapper{\n  display: block;\n}\n.videoContainer{\n  position: relative;\n}\n.videoAbsolute{\n  position: absolute;\n  top: -48px;\n}\n.questionBoxScroll{\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  z-index: 100;\n  background-color: var(--white);\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.08);\n}\n.video{\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n      justify-content: center;\n      align-items: center;\n      flex-direction: column;\n      gap: 10px;\n}\n.videoInnerImageIcon{\n  width: 180px;\n  height: auto;\n  padding: 20px;\n}\n.videoInnerTextTitle{\n  color: var(--white);\n}\n.videoInnerImage{\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `global_wrapper__1r5aK`,
	"container": `global_container__y8Nfh`,
	"ptbl10": `global_ptbl10__piZ7V`,
	"ptbl15": `global_ptbl15__elFG-`,
	"ptbl12": `global_ptbl12__NGXPP`,
	"pt10": `global_pt10__yyOj-`,
	"pb10": `global_pb10__0a7yB`,
	"pb20": `global_pb20__NxsAm`,
	"ptb10": `global_ptb10__mlVOD`,
	"pl10": `global_pl10__rbL5y`,
	"pr10": `global_pr10__f20KT`,
	"plr10": `global_plr10__JnjLT`,
	"mt10": `global_mt10__LUIG2`,
	"mb10": `global_mb10__NsY+w`,
	"flex0": `global_flex0__IVIPD`,
	"flex1": `global_flex1__B3ULo`,
	"flex2": `global_flex2__4PFPt`,
	"flex3": `global_flex3__EsyNm`,
	"flex4": `global_flex4__xhvaE`,
	"flex5": `global_flex5__bYRMQ`,
	"flex6": `global_flex6__AM9dY`,
	"questionBox": `global_questionBox__LcqM6`,
	"questionBoxInner": `global_questionBoxInner__EAhnx`,
	"blankspacetop": `global_blankspacetop__1oIX2`,
	"inlineError": `global_inlineError__I8SYK`,
	"gredintbox": `global_gredintbox__kNQlO`,
	"marginTopsticky": `global_marginTopsticky__octf-`,
	"animateBox": `global_animateBox__pnBLu`,
	"bannerImage": `global_bannerImage__erAgt`,
	"tierBox": `global_tierBox__-Hdf7`,
	"innwrapper": `global_innwrapper__pifpL`,
	"videoContainer": `global_videoContainer__FoQ7m`,
	"videoAbsolute": `global_videoAbsolute__n8mSc`,
	"questionBoxScroll": `global_questionBoxScroll__ulWdm`,
	"video": `global_video__2-ouU`,
	"videoInnerImageIcon": `global_videoInnerImageIcon__uHtar`,
	"videoInnerTextTitle": `global_videoInnerTextTitle__UfJr+`,
	"videoInnerImage": `global_videoInnerImage__rKBrA`
};
export default ___CSS_LOADER_EXPORT___;
